module.exports = {
  apikey: "AbcIh6M5QAqOtcd40KmCvz"
}
